import React from "react";

import * as Assets from "../../assets";
import classes from "./Input.module.scss";

interface IProps {
	value: string | number;
	onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
	onEnterPress?: () => void;
	name?: string;
	autoComplete?: string;
	type?: string;
	placeholder?: string;
	disabled?: boolean;
}

export const Input = (props: IProps) => {
	const onKeyPressHandler = (event: React.KeyboardEvent<HTMLInputElement>) => {
		if (event.key === "Enter" && !!props.onEnterPress) {
			props.onEnterPress();
		}
	};

	return (
		<div className={classes.container}>
			<input className={classes.input} onKeyPress={onKeyPressHandler} {...props} />
			{!!props.onEnterPress && !!props.value && (<img className={classes.enterImg}
				src={Assets.Enter}
				alt={"Enter"}
				onClick={props.onEnterPress} />
			)}
		</div>
	);
};
